/**
 * Public portal translations. Keep keys stable across languages.
 * Languages: en (English), hi (हिन्दी), ta (தமிழ்), mr (मराठी)
 */

export const LANGS = [
  { code: "en", short: "EN", label: "English" },
  { code: "hi", short: "हि", label: "हिन्दी" },
  { code: "ta", short: "த", label: "தமிழ்" },
  { code: "mr", short: "म", label: "मराठी" },
];

const dict = {
  en: {
    payment_portal: "Payment portal",
    hello: "Hello",
    amount_due: "Amount due",
    cycle: "Cycle",
    due_date: "Due date",
    status: "Status",
    status_paid: "PAID",
    status_pending: "PENDING",
    status_overdue: "OVERDUE",
    status_pending_review: "PENDING REVIEW",
    ways_to_pay: "Ways to pay",
    no_options: "No payment options have been configured yet. Please contact {business}.",
    pay: "Pay",
    already_paid_title: "Already paid via UPI or bank transfer?",
    already_paid_sub: "Let us know",
    already_paid_desc:
      "If you paid using an offline method (UPI, cash, cheque), tell us the reference so {business} can verify and mark your payment complete.",
    reference_label: "Reference / UTR / transaction id",
    reference_ph: "e.g. UPI/423876329871",
    note_label: "Note (optional)",
    note_ph: "Paid on 12 Feb via UPI",
    receipt_label: "Receipt / screenshot (optional)",
    receipt_hint: "Attach a screenshot of your UPI receipt",
    receipt_size: "JPG, PNG or WEBP — max 5 MB",
    remove: "Remove",
    i_have_paid: "I have paid",
    reporting: "Reporting…",
    thank_you_no_receipt: "Thank you — payment reported. The business will verify shortly.",
    thank_you_with_receipt: "Thank you — payment and receipt uploaded. The business will verify shortly.",
    ty_headline: "You're all set!",
    ty_sub: "Your payment is on its way to being verified. Thanks for keeping things on track.",
    ty_next_steps: "We'll email or WhatsApp you the moment {business} confirms it.",
    report_another: "Report another payment",
    recent_payments: "Recent payments",
    powered_by: "Powered by",
    link_unavailable: "Link unavailable",
    monthly: "Monthly",
    quarterly: "Quarterly",
    yearly: "Yearly",
    manual: "manual",
    razorpay: "razorpay",
    upi_method: "upi",
    external: "external",
    self_reported: "self reported",
    language_label: "Language",
    err_only_image: "Please attach an image (JPG, PNG or WEBP).",
    err_size: "Receipt must be smaller than 5 MB.",
    err_submit: "Could not submit",
    loading: "Loading…",
    remind_title: "Not ready yet?",
    remind_desc: "We'll send you a fresh reminder tomorrow with the same payment options.",
    remind_me_tomorrow: "Remind me tomorrow",
    remind_scheduling: "Scheduling…",
    remind_scheduled: "Reminder set for {date}. We'll ping you then.",
    remind_err: "Could not schedule reminder. Try again in a bit.",
  },
  hi: {
    payment_portal: "भुगतान पोर्टल",
    hello: "नमस्ते",
    amount_due: "देय राशि",
    cycle: "चक्र",
    due_date: "देय तिथि",
    status: "स्थिति",
    status_paid: "भुगतान हुआ",
    status_pending: "बाकी",
    status_overdue: "बकाया",
    status_pending_review: "जाँच जारी",
    ways_to_pay: "भुगतान के तरीके",
    no_options:
      "अभी कोई भुगतान विकल्प उपलब्ध नहीं है। कृपया {business} से संपर्क करें।",
    pay: "भुगतान करें",
    already_paid_title: "क्या आपने पहले ही UPI या बैंक से भुगतान कर दिया है?",
    already_paid_sub: "हमें बताएँ",
    already_paid_desc:
      "यदि आपने ऑफ़लाइन तरीके (UPI, नकद, चेक) से भुगतान किया है, तो कृपया संदर्भ (reference) दें ताकि {business} इसे सत्यापित कर सके।",
    reference_label: "संदर्भ / UTR / लेन-देन आईडी",
    reference_ph: "जैसे UPI/423876329871",
    note_label: "टिप्पणी (वैकल्पिक)",
    note_ph: "12 फ़रवरी को UPI से भुगतान किया",
    receipt_label: "रसीद / स्क्रीनशॉट (वैकल्पिक)",
    receipt_hint: "अपनी UPI रसीद का स्क्रीनशॉट संलग्न करें",
    receipt_size: "JPG, PNG या WEBP — अधिकतम 5 MB",
    remove: "हटाएँ",
    i_have_paid: "मैंने भुगतान कर दिया है",
    reporting: "भेजा जा रहा है…",
    thank_you_no_receipt: "धन्यवाद — भुगतान की जानकारी दर्ज हो गई है। जल्द ही सत्यापन किया जाएगा।",
    thank_you_with_receipt: "धन्यवाद — भुगतान और रसीद अपलोड हो गई। जल्द ही सत्यापन किया जाएगा।",
    ty_headline: "बस हो गया!",
    ty_sub: "आपके भुगतान का सत्यापन जल्द ही किया जाएगा। समय पर चुकाने के लिए धन्यवाद।",
    ty_next_steps: "जैसे ही {business} इसे पुष्टि करेगा, हम आपको ईमेल या WhatsApp पर सूचित करेंगे।",
    report_another: "और भुगतान दर्ज करें",
    recent_payments: "हाल के भुगतान",
    powered_by: "द्वारा संचालित",
    link_unavailable: "लिंक उपलब्ध नहीं है",
    monthly: "मासिक",
    quarterly: "त्रैमासिक",
    yearly: "वार्षिक",
    manual: "मैनुअल",
    razorpay: "रेज़रपे",
    upi_method: "UPI",
    external: "बाहरी",
    self_reported: "स्व-सूचित",
    language_label: "भाषा",
    err_only_image: "कृपया एक छवि (JPG, PNG या WEBP) चुनें।",
    err_size: "रसीद 5 MB से छोटी होनी चाहिए।",
    err_submit: "जमा नहीं हो सका",
    loading: "लोड हो रहा है…",
    remind_title: "अभी तैयार नहीं हैं?",
    remind_desc: "हम कल आपको वही भुगतान विकल्पों के साथ एक नई याद दिला देंगे।",
    remind_me_tomorrow: "कल याद दिलाएँ",
    remind_scheduling: "सेट किया जा रहा है…",
    remind_scheduled: "रिमाइंडर {date} को सेट है। हम उस दिन आपको सूचित करेंगे।",
    remind_err: "रिमाइंडर सेट नहीं हो सका। थोड़ी देर बाद पुनः प्रयास करें।",
  },
  ta: {
    payment_portal: "கட்டண போர்டல்",
    hello: "வணக்கம்",
    amount_due: "செலுத்த வேண்டிய தொகை",
    cycle: "காலம்",
    due_date: "காலக்கெடு",
    status: "நிலை",
    status_paid: "செலுத்தப்பட்டது",
    status_pending: "நிலுவை",
    status_overdue: "தாமதம்",
    status_pending_review: "சரிபார்ப்பில்",
    ways_to_pay: "பணம் செலுத்தும் வழிகள்",
    no_options:
      "இதுவரை பணம் செலுத்தும் விருப்பம் அமைக்கப்படவில்லை. தயவுசெய்து {business}-ஐ தொடர்பு கொள்ளவும்.",
    pay: "செலுத்து",
    already_paid_title: "UPI அல்லது வங்கியில் ஏற்கனவே செலுத்திவிட்டீர்களா?",
    already_paid_sub: "எங்களிடம் தெரிவிக்கவும்",
    already_paid_desc:
      "நீங்கள் ஆஃப்லைனில் (UPI, ரொக்கம், காசோலை) செலுத்தியிருந்தால், தயவுசெய்து பரிமாற்ற எண்ணைக் கொடுங்கள். {business} அதை சரிபார்ப்பார்.",
    reference_label: "குறிப்பு / UTR / பரிமாற்ற ஐடி",
    reference_ph: "எ.கா. UPI/423876329871",
    note_label: "குறிப்பு (விருப்பமானது)",
    note_ph: "பிப்ரவரி 12 அன்று UPI-ல் செலுத்தினேன்",
    receipt_label: "ரசீது / ஸ்கிரீன்ஷாட் (விருப்பமானது)",
    receipt_hint: "உங்கள் UPI ரசீது ஸ்கிரீன்ஷாட்டை இணைக்கவும்",
    receipt_size: "JPG, PNG அல்லது WEBP — அதிகபட்சம் 5 MB",
    remove: "அகற்று",
    i_have_paid: "நான் செலுத்திவிட்டேன்",
    reporting: "அனுப்புகிறது…",
    thank_you_no_receipt: "நன்றி — கட்டணம் பதிவு செய்யப்பட்டது. விரைவில் சரிபார்க்கப்படும்.",
    thank_you_with_receipt: "நன்றி — கட்டணமும் ரசீதும் பதிவு செய்யப்பட்டன. விரைவில் சரிபார்க்கப்படும்.",
    ty_headline: "செய்து முடிந்தது!",
    ty_sub: "உங்கள் கட்டணம் விரைவில் சரிபார்க்கப்படும். சரியான நேரத்தில் செலுத்தியதற்கு நன்றி.",
    ty_next_steps: "{business} இதை உறுதிப்படுத்தியவுடன், மின்னஞ்சல் அல்லது WhatsApp வழியாகத் தெரிவிப்போம்.",
    report_another: "மற்றொரு கட்டணத்தை பதிவு செய்",
    recent_payments: "சமீபத்திய பணம் செலுத்துதல்கள்",
    powered_by: "இயக்குபவர்",
    link_unavailable: "இணைப்பு கிடைக்கவில்லை",
    monthly: "மாதாந்திரம்",
    quarterly: "காலாண்டு",
    yearly: "வருடாந்திரம்",
    manual: "கைமுறை",
    razorpay: "ரேசர்பே",
    upi_method: "UPI",
    external: "வெளிப்புற",
    self_reported: "சுய அறிக்கை",
    language_label: "மொழி",
    err_only_image: "தயவுசெய்து ஒரு படத்தை (JPG, PNG அல்லது WEBP) இணைக்கவும்.",
    err_size: "ரசீது 5 MB-க்குள் இருக்க வேண்டும்.",
    err_submit: "சமர்ப்பிக்க முடியவில்லை",
    loading: "ஏற்றுகிறது…",
    remind_title: "இப்போது தயாராக இல்லையா?",
    remind_desc: "நாளை அதே பணம் செலுத்தும் விருப்பங்களுடன் நினைவூட்டல் அனுப்புவோம்.",
    remind_me_tomorrow: "நாளை நினைவூட்டு",
    remind_scheduling: "அமைக்கிறது…",
    remind_scheduled: "நினைவூட்டல் {date} அன்று அமைக்கப்பட்டது. அன்று அழைப்போம்.",
    remind_err: "நினைவூட்டல் அமைக்க முடியவில்லை. சிறிது நேரம் கழித்து முயற்சிக்கவும்.",
  },
  mr: {
    payment_portal: "पेमेंट पोर्टल",
    hello: "नमस्कार",
    amount_due: "देय रक्कम",
    cycle: "कालावधी",
    due_date: "देय तारीख",
    status: "स्थिती",
    status_paid: "भरले",
    status_pending: "प्रलंबित",
    status_overdue: "थकबाकी",
    status_pending_review: "पडताळणी सुरू",
    ways_to_pay: "पेमेंट पर्याय",
    no_options:
      "अद्याप कोणतेही पेमेंट पर्याय उपलब्ध नाहीत. कृपया {business} शी संपर्क साधा.",
    pay: "पेमेंट करा",
    already_paid_title: "UPI किंवा बँकेने आधीच पेमेंट केले आहे का?",
    already_paid_sub: "आम्हाला कळवा",
    already_paid_desc:
      "जर आपण ऑफलाइन पद्धतीने (UPI, रोख, धनादेश) पेमेंट केले असेल, तर संदर्भ द्या जेणेकरून {business} त्याची पडताळणी करू शकेल.",
    reference_label: "संदर्भ / UTR / व्यवहार आयडी",
    reference_ph: "उदा. UPI/423876329871",
    note_label: "टीप (ऐच्छिक)",
    note_ph: "12 फेब्रुवारी रोजी UPI ने पेमेंट केले",
    receipt_label: "पावती / स्क्रीनशॉट (ऐच्छिक)",
    receipt_hint: "आपल्या UPI पावतीचा स्क्रीनशॉट संलग्न करा",
    receipt_size: "JPG, PNG किंवा WEBP — कमाल 5 MB",
    remove: "काढा",
    i_have_paid: "मी पेमेंट केले आहे",
    reporting: "पाठवत आहे…",
    thank_you_no_receipt: "धन्यवाद — पेमेंट नोंदवले. लवकरच पडताळणी केली जाईल.",
    thank_you_with_receipt: "धन्यवाद — पेमेंट आणि पावती अपलोड झाली. लवकरच पडताळणी केली जाईल.",
    ty_headline: "झालं!",
    ty_sub: "तुमच्या पेमेंटची पडताळणी लवकरच केली जाईल. वेळेवर पेमेंट केल्याबद्दल धन्यवाद.",
    ty_next_steps: "{business} पुष्टी करताच आम्ही तुम्हाला ईमेल किंवा WhatsApp वर कळवू.",
    report_another: "आणखी एक पेमेंट नोंदवा",
    recent_payments: "अलीकडील पेमेंट्स",
    powered_by: "प्रस्तुत करते",
    link_unavailable: "लिंक उपलब्ध नाही",
    monthly: "मासिक",
    quarterly: "त्रैमासिक",
    yearly: "वार्षिक",
    manual: "मॅन्युअल",
    razorpay: "रेझरपे",
    upi_method: "UPI",
    external: "बाह्य",
    self_reported: "स्व-नोंदवलेले",
    language_label: "भाषा",
    err_only_image: "कृपया प्रतिमा (JPG, PNG किंवा WEBP) निवडा.",
    err_size: "पावती 5 MB पेक्षा लहान असावी.",
    err_submit: "सबमिट झाले नाही",
    loading: "लोड होत आहे…",
    remind_title: "अजून तयार नाही?",
    remind_desc: "उद्या त्याच पेमेंट पर्यायांसह आम्ही तुम्हाला पुन्हा आठवण करून देऊ.",
    remind_me_tomorrow: "उद्या आठवण करा",
    remind_scheduling: "सेट करत आहे…",
    remind_scheduled: "स्मरणपत्र {date} रोजी सेट केले आहे. त्या दिवशी आम्ही तुम्हाला कळवू.",
    remind_err: "स्मरणपत्र सेट झाले नाही. थोड्या वेळाने पुन्हा प्रयत्न करा.",
  },
};

export const supportedLang = (code) =>
  LANGS.some((l) => l.code === code) ? code : "en";

/**
 * Detect the best supported language from browser hints.
 * Order: navigator.languages -> navigator.language -> navigator.userLanguage.
 * Matches on primary subtag (e.g. "hi-IN" -> "hi"). Falls back to "en".
 */
export function detectBrowserLang() {
  if (typeof navigator === "undefined") return "en";
  const raw = [
    ...(navigator.languages || []),
    navigator.language,
    navigator.userLanguage,
  ].filter(Boolean);
  const supported = new Set(LANGS.map((l) => l.code));
  for (const tag of raw) {
    const primary = String(tag).toLowerCase().split(/[-_]/)[0];
    if (supported.has(primary)) return primary;
  }
  return "en";
}

export function makeT(lang, vars = {}) {
  const l = supportedLang(lang);
  return (key) => {
    const raw = dict[l][key] || dict.en[key] || key;
    return Object.keys(vars).reduce(
      (acc, k) => acc.replaceAll(`{${k}}`, vars[k]),
      raw
    );
  };
}

/** Map billing_cycle / method server values to translated labels */
export function localizeCycle(lang, cycle) {
  return makeT(lang)(cycle) || cycle;
}
export function localizeMethod(lang, method) {
  const t = makeT(lang);
  const key = method === "upi" ? "upi_method" : method;
  const v = t(key);
  // if no translation exists (e.g. self_reported), fall back to en dictionary
  return v || method;
}
